export const timeSlots = [
    { id: 1, value: "12:00 AM-12:30 AM", label: "12:00 AM - 12:30 AM", from: "12:00 AM" },
    { id: 2, value: "12:30 AM-01:00 AM", label: "12:30 AM - 01:00 AM", from: "12:30 AM" },
    { id: 3, value: "01:00 AM-01:30 AM", label: "01:00 AM - 01:30 AM", from: "01:00 AM" },
    { id: 4, value: "01:30 AM-02:00 AM", label: "01:30 AM - 02:00 AM", from: "01:30 AM" },
    { id: 5, value: "02:00 AM-02:30 AM", label: "02:00 AM - 02:30 AM", from: "02:00 AM" },
    { id: 6, value: "02:30 AM-03:00 AM", label: "02:30 AM - 03:00 AM", from: "02:30 AM" },
    { id: 7, value: "03:00 AM-03:30 AM", label: "03:00 AM - 03:30 AM", from: "03:00 AM" },
    { id: 8, value: "03:30 AM-04:00 AM", label: "03:30 AM - 04:00 AM", from: "03:30 AM" },
    { id: 9, value: "04:00 AM-04:30 AM", label: "04:00 AM - 04:30 AM", from: "04:00 AM" },
    { id: 10, value: "04:30 AM-05:00 AM", label: "04:30 AM - 05:00 AM", from: "04:30 AM" },
    { id: 11, value: "05:00 AM-05:30 AM", label: "05:00 AM - 05:30 AM", from: "05:00 AM" },
    { id: 12, value: "05:30 AM-06:00 AM", label: "05:30 AM - 06:00 AM", from: "05:30 AM" },
    { id: 13, value: "06:00 AM-06:30 AM", label: "06:00 AM - 06:30 AM", from: "06:00 AM" },
    { id: 14, value: "06:30 AM-07:00 AM", label: "06:30 AM - 07:00 AM", from: "06:30 AM" },
    { id: 15, value: "07:00 AM-07:30 AM", label: "07:00 AM - 07:30 AM", from: "07:00 AM" },
    { id: 16, value: "07:30 AM-08:00 AM", label: "07:30 AM - 08:00 AM", from: "07:30 AM" },
    { id: 17, value: "08:00 AM-08:30 AM", label: "08:00 AM - 08:30 AM", from: "08:00 AM" },
    { id: 18, value: "08:30 AM-09:00 AM", label: "08:30 AM - 09:00 AM", from: "08:30 AM" },
    { id: 19, value: "09:00 AM-09:30 AM", label: "09:00 AM - 09:30 AM", from: "09:00 AM" },
    { id: 20, value: "09:30 AM-10:00 AM", label: "09:30 AM - 10:00 AM", from: "09:30 AM" },
    { id: 21, value: "10:00 AM-10:30 AM", label: "10:00 AM - 10:30 AM", from: "10:00 AM" },
    { id: 22, value: "10:30 AM-11:00 AM", label: "10:30 AM - 11:00 AM", from: "10:30 AM" },
    { id: 23, value: "11:00 AM-11:30 AM", label: "11:00 AM - 11:30 AM", from: "11:00 AM" },
    { id: 24, value: "11:30 AM-12:00 PM", label: "11:30 AM - 12:00 PM", from: "11:30 AM" },
    { id: 25, value: "12:00 PM-12:30 PM", label: "12:00 PM - 12:30 PM", from: "12:00 PM" },
    { id: 26, value: "12:30 PM-01:00 PM", label: "12:30 PM - 01:00 PM", from: "12:30 PM" },
    { id: 27, value: "01:00 PM-01:30 PM", label: "01:00 PM - 01:30 PM", from: "01:00 PM" },
    { id: 28, value: "01:30 PM-02:00 PM", label: "01:30 PM - 02:00 PM", from: "01:30 PM" },
    { id: 29, value: "02:00 PM-02:30 PM", label: "02:00 PM - 02:30 PM", from: "02:00 PM" },
    { id: 30, value: "02:30 PM-03:00 PM", label: "02:30 PM - 03:00 PM", from: "02:30 PM" },
    { id: 31, value: "03:00 PM-03:30 PM", label: "03:00 PM - 03:30 PM", from: "03:00 PM" },
    { id: 32, value: "03:30 PM-04:00 PM", label: "03:30 PM - 04:00 PM", from: "03:30 PM" },
    { id: 33, value: "04:00 PM-04:30 PM", label: "04:00 PM - 04:30 PM", from: "04:00 PM" },
    { id: 34, value: "04:30 PM-05:00 PM", label: "04:30 PM - 05:00 PM", from: "04:30 PM" },
    { id: 35, value: "05:00 PM-05:30 PM", label: "05:00 PM - 05:30 PM", from: "05:00 PM" },
    { id: 36, value: "05:30 PM-06:00 PM", label: "05:30 PM - 06:00 PM", from: "05:30 PM" },
    { id: 37, value: "06:00 PM-06:30 PM", label: "06:00 PM - 06:30 PM", from: "06:00 PM" },
    { id: 38, value: "06:30 PM-07:00 PM", label: "06:30 PM - 07:00 PM", from: "06:30 PM" },
    { id: 39, value: "07:00 PM-07:30 PM", label: "07:00 PM - 07:30 PM", from: "07:00 PM" },
    { id: 40, value: "07:30 PM-08:00 PM", label: "07:30 PM - 08:00 PM", from: "07:30 PM" },
    { id: 41, value: "08:00 PM-08:30 PM", label: "08:00 PM - 08:30 PM", from: "08:00 PM" },
    { id: 42, value: "08:30 PM-09:00 PM", label: "08:30 PM - 09:00 PM", from: "08:30 PM" },
    { id: 43, value: "09:00 PM-09:30 PM", label: "09:00 PM - 09:30 PM", from: "09:00 PM" },
    { id: 44, value: "09:30 PM-10:00 PM", label: "09:30 PM - 10:00 PM", from: "09:30 PM" },
    { id: 45, value: "10:00 PM-10:30 PM", label: "10:00 PM - 10:30 PM", from: "10:00 PM" },
    { id: 46, value: "10:30 PM-11:00 PM", label: "10:30 PM - 11:00 PM", from: "10:30 PM" },
    { id: 47, value: "11:00 PM-11:30 PM", label: "11:00 PM - 11:30 PM", from: "11:00 PM" },
    { id: 48, value: "11:30 PM-12:00 AM", label: "11:30 PM - 12:00 AM", from: "11:30 PM" },
]
export const aryIanaTimeZones = [
    "Europe/Andorra",
    "Asia/Dubai",
    "Asia/Kabul",
    "Europe/Tirane",
    "Asia/Yerevan",
    "Antarctica/Casey",
    "Antarctica/Davis",
    "Antarctica/DumontDUrville",
    "Antarctica/Mawson",
    "Antarctica/Palmer",
    "Antarctica/Rothera",
    "Antarctica/Syowa",
    "Antarctica/Troll",
    "Antarctica/Vostok",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Cordoba",
    "America/Argentina/Salta",
    "America/Argentina/Jujuy",
    "America/Argentina/Tucuman",
    "America/Argentina/Catamarca",
    "America/Argentina/La_Rioja",
    "America/Argentina/San_Juan",
    "America/Argentina/Mendoza",
    "America/Argentina/San_Luis",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Ushuaia",
    "Pacific/Pago_Pago",
    "Europe/Vienna",
    "Australia/Lord_Howe",
    "Antarctica/Macquarie",
    "Australia/Hobart",
    "Australia/Currie",
    "Australia/Melbourne",
    "Australia/Sydney",
    "Australia/Broken_Hill",
    "Australia/Brisbane",
    "Australia/Lindeman",
    "Australia/Adelaide",
    "Australia/Darwin",
    "Australia/Perth",
    "Australia/Eucla",
    "Asia/Baku",
    "America/Barbados",
    "Asia/Dhaka",
    "Europe/Brussels",
    "Europe/Sofia",
    "Atlantic/Bermuda",
    "Asia/Brunei",
    "America/La_Paz",
    "America/Noronha",
    "America/Belem",
    "America/Fortaleza",
    "America/Recife",
    "America/Araguaina",
    "America/Maceio",
    "America/Bahia",
    "America/Sao_Paulo",
    "America/Campo_Grande",
    "America/Cuiaba",
    "America/Santarem",
    "America/Porto_Velho",
    "America/Boa_Vista",
    "America/Manaus",
    "America/Eirunepe",
    "America/Rio_Branco",
    "America/Nassau",
    "Asia/Thimphu",
    "Europe/Minsk",
    "America/Belize",
    "America/St_Johns",
    "America/Halifax",
    "America/Glace_Bay",
    "America/Moncton",
    "America/Goose_Bay",
    "America/Blanc-Sablon",
    "America/Toronto",
    "America/Nipigon",
    "America/Thunder_Bay",
    "America/Iqaluit",
    "America/Pangnirtung",
    "America/Atikokan",
    "America/Winnipeg",
    "America/Rainy_River",
    "America/Resolute",
    "America/Rankin_Inlet",
    "America/Regina",
    "America/Swift_Current",
    "America/Edmonton",
    "America/Cambridge_Bay",
    "America/Yellowknife",
    "America/Inuvik",
    "America/Creston",
    "America/Dawson_Creek",
    "America/Fort_Nelson",
    "America/Vancouver",
    "America/Whitehorse",
    "America/Dawson",
    "Indian/Cocos",
    "Europe/Zurich",
    "Africa/Abidjan",
    "Pacific/Rarotonga",
    "America/Santiago",
    "America/Punta_Arenas",
    "Pacific/Easter",
    "Asia/Shanghai",
    "Asia/Urumqi",
    "America/Bogota",
    "America/Costa_Rica",
    "America/Havana",
    "Atlantic/Cape_Verde",
    "America/Curacao",
    "Indian/Christmas",
    "Asia/Nicosia",
    "Asia/Famagusta",
    "Europe/Prague",
    "Europe/Berlin",
    "Europe/Copenhagen",
    "America/Santo_Domingo",
    "Africa/Algiers",
    "America/Guayaquil",
    "Pacific/Galapagos",
    "Europe/Tallinn",
    "Africa/Cairo",
    "Africa/El_Aaiun",
    "Europe/Madrid",
    "Africa/Ceuta",
    "Atlantic/Canary",
    "Europe/Helsinki",
    "Pacific/Fiji",
    "Atlantic/Stanley",
    "Pacific/Chuuk",
    "Pacific/Pohnpei",
    "Pacific/Kosrae",
    "Atlantic/Faroe",
    "Europe/Paris",
    "Europe/London",
    "Asia/Tbilisi",
    "America/Cayenne",
    "Africa/Accra",
    "Europe/Gibraltar",
    "America/Godthab",
    "America/Danmarkshavn",
    "America/Scoresbysund",
    "America/Thule",
    "Europe/Athens",
    "Atlantic/South_Georgia",
    "America/Guatemala",
    "Pacific/Guam",
    "Africa/Bissau",
    "America/Guyana",
    "Asia/Hong_Kong",
    "America/Tegucigalpa",
    "America/Port-au-Prince",
    "Europe/Budapest",
    "Asia/Jakarta",
    "Asia/Pontianak",
    "Asia/Makassar",
    "Asia/Jayapura",
    "Europe/Dublin",
    "Asia/Jerusalem",
    "Asia/Kolkata",
    "Indian/Chagos",
    "Asia/Baghdad",
    "Asia/Tehran",
    "Atlantic/Reykjavik",
    "Europe/Rome",
    "America/Jamaica",
    "Asia/Amman",
    "Asia/Tokyo",
    "Africa/Nairobi",
    "Asia/Bishkek",
    "Pacific/Tarawa",
    "Pacific/Enderbury",
    "Pacific/Kiritimati",
    "Asia/Pyongyang",
    "Asia/Seoul",
    "Asia/Almaty",
    "Asia/Qyzylorda",
    "Asia/Qostanay",
    "Asia/Aqtobe",
    "Asia/Aqtau",
    "Asia/Atyrau",
    "Asia/Oral",
    "Asia/Beirut",
    "Asia/Colombo",
    "Africa/Monrovia",
    "Europe/Vilnius",
    "Europe/Luxembourg",
    "Europe/Riga",
    "Africa/Tripoli",
    "Africa/Casablanca",
    "Europe/Monaco",
    "Europe/Chisinau",
    "Pacific/Majuro",
    "Pacific/Kwajalein",
    "Asia/Yangon",
    "Asia/Ulaanbaatar",
    "Asia/Hovd",
    "Asia/Choibalsan",
    "Asia/Macau",
    "America/Martinique",
    "Europe/Malta",
    "Indian/Mauritius",
    "Indian/Maldives",
    "America/Mexico_City",
    "America/Cancun",
    "America/Merida",
    "America/Monterrey",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Chihuahua",
    "America/Ojinaga",
    "America/Hermosillo",
    "America/Tijuana",
    "America/Bahia_Banderas",
    "Asia/Kuala_Lumpur",
    "Asia/Kuching",
    "Africa/Maputo",
    "Africa/Windhoek",
    "Pacific/Noumea",
    "Pacific/Norfolk",
    "Africa/Lagos",
    "America/Managua",
    "Europe/Amsterdam",
    "Europe/Oslo",
    "Asia/Kathmandu",
    "Pacific/Nauru",
    "Pacific/Niue",
    "Pacific/Auckland",
    "Pacific/Chatham",
    "America/Panama",
    "America/Lima",
    "Pacific/Tahiti",
    "Pacific/Marquesas",
    "Pacific/Gambier",
    "Pacific/Port_Moresby",
    "Pacific/Bougainville",
    "Asia/Manila",
    "Asia/Karachi",
    "Europe/Warsaw",
    "America/Miquelon",
    "Pacific/Pitcairn",
    "America/Puerto_Rico",
    "Asia/Gaza",
    "Asia/Hebron",
    "Europe/Lisbon",
    "Atlantic/Madeira",
    "Atlantic/Azores",
    "Pacific/Palau",
    "America/Asuncion",
    "Asia/Qatar",
    "Indian/Reunion",
    "Europe/Bucharest",
    "Europe/Belgrade",
    "Europe/Kaliningrad",
    "Europe/Moscow",
    "Europe/Simferopol",
    "Europe/Kirov",
    "Europe/Astrakhan",
    "Europe/Volgograd",
    "Europe/Saratov",
    "Europe/Ulyanovsk",
    "Europe/Samara",
    "Asia/Yekaterinburg",
    "Asia/Omsk",
    "Asia/Novosibirsk",
    "Asia/Barnaul",
    "Asia/Tomsk",
    "Asia/Novokuznetsk",
    "Asia/Krasnoyarsk",
    "Asia/Irkutsk",
    "Asia/Chita",
    "Asia/Yakutsk",
    "Asia/Khandyga",
    "Asia/Vladivostok",
    "Asia/Ust-Nera",
    "Asia/Magadan",
    "Asia/Sakhalin",
    "Asia/Srednekolymsk",
    "Asia/Kamchatka",
    "Asia/Anadyr",
    "Asia/Riyadh",
    "Pacific/Guadalcanal",
    "Indian/Mahe",
    "Africa/Khartoum",
    "Europe/Stockholm",
    "Asia/Singapore",
    "America/Paramaribo",
    "Africa/Juba",
    "Africa/Sao_Tome",
    "America/El_Salvador",
    "Asia/Damascus",
    "America/Grand_Turk",
    "Africa/Ndjamena",
    "Indian/Kerguelen",
    "Asia/Bangkok",
    "Asia/Dushanbe",
    "Pacific/Fakaofo",
    "Asia/Dili",
    "Asia/Ashgabat",
    "Africa/Tunis",
    "Pacific/Tongatapu",
    "Europe/Istanbul",
    "America/Port_of_Spain",
    "Pacific/Funafuti",
    "Asia/Taipei",
    "Europe/Kiev",
    "Europe/Uzhgorod",
    "Europe/Zaporozhye",
    "Pacific/Wake",
    "America/New_York",
    "America/Detroit",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Indiana/Indianapolis",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Vevay",
    "America/Chicago",
    "America/Indiana/Tell_City",
    "America/Indiana/Knox",
    "America/Menominee",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/North_Dakota/Beulah",
    "America/Denver",
    "America/Boise",
    "America/Phoenix",
    "America/Los_Angeles",
    "America/Anchorage",
    "America/Juneau",
    "America/Sitka",
    "America/Metlakatla",
    "America/Yakutat",
    "America/Nome",
    "America/Adak",
    "Pacific/Honolulu",
    "America/Montevideo",
    "Asia/Samarkand",
    "Asia/Tashkent",
    "America/Caracas",
    "Asia/Ho_Chi_Minh",
    "Pacific/Efate",
    "Pacific/Wallis",
    "Pacific/Apia",
    "Africa/Johannesburg",
]
export const type = [
    { label: "Hot", value: "1" },
    { label: "Cold", value: "2" },
    { label: "Warm", value: "3" },
    { label: "Normal", value: "4" },
    { label: "Extreme Hot", value: "5" },
]